interface ShopRectangleDownProps {
    color?: string;
    width?: string | string;
    height?: string | string;
    className?: string;
    svgProps?: React.SVGProps<SVGSVGElement>;
}

const ShopRectangleDown = ({ color = 'currentColor', width = '20', height = '10', className, svgProps }: ShopRectangleDownProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 10" fill="none" className={className} {...svgProps}>
            <path fillRule="evenodd" clipRule="evenodd" d="M4.0717 0L10 5.80821L15.9279 1.74315e-05L20 0L10 10L0 0L4.0717 0Z" fill={color} />
        </svg>
    );
};

export default ShopRectangleDown;
